import React, { useState, useEffect } from "react";
import {
  Button,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
} from "@material-ui/core";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import * as moment from "moment";
import { useHistory } from "react-router-dom";
import { DatePicker } from "@material-ui/pickers";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { DATE_FORMATS } from "../../configs/constant";
import { getApi } from "../../services/api";
import { ATTANDENCEREPORT, USERS } from "../../configs/urls";
import Loader from "../Loader";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

export default function Attendance(props) {
  const classes = useStyles();
  const history = useHistory();

  const [attendanceData, setAttendanceData] = useState([]);
  const [userList, setUserList] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf("month"));
  const [toDate, setToDate] = useState(fromDate);

  useEffect(() => {
    if (fromDate) {
      setToDate(fromDate);
    }
  }, [fromDate]);

  useEffect(() => {
    setIsRequesting(true);

    const attendanceApi = getApi(ATTANDENCEREPORT, {
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD"),
    });

    const userApi = getApi(USERS);
    const temperedData = {};
    axios
      .all([userApi, attendanceApi])
      .then((res) => {
        if (res[0] && res[0].data) {
          setUserList(res[0].data);
        }

        if (res[1] && res[1].data) {
          const tempAttendanceData = res[1].data.map((attendanceItem) => {
            const index = res[0]?.data.findIndex(
              (user) => user?.id === attendanceItem.user_id
            );
            attendanceItem.name = res[0]?.data[index]?.name;
            if (temperedData[attendanceItem.user_id]) {
              temperedData[attendanceItem.user_id].push(attendanceItem);
            } else {
              temperedData[attendanceItem.user_id] = [{ ...attendanceItem }];
            }
            return attendanceItem;
          });

          setAttendanceData(temperedData);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setIsRequesting(false);
      });
  }, [fromDate, toDate]); //eslint-disable-line

  const viewProjectDetail = (project) => {
    history.push("/admin/project/view/" + project.id);
  };

  const renderProject = () => (
    <TableContainer component={Paper}>
      <Table
        className={classes.table}
        id="table-to-xls"
        aria-label="caption table"
      >
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Shift Start Date & time</TableCell>
            <TableCell>Shift End Date & time</TableCell>
            <TableCell>Break Time (Accumulative)</TableCell>
            <TableCell>Productive Hours</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(attendanceData).map((item, idx) => {
            const userData = userList.find((user) => user.id == item);
            const startShift = attendanceData[item]?.filter(
              (attendencOj) => attendencOj.status === "start_shift"
            );
            const endShift =
              attendanceData[item]?.filter(
                (attendencOj) => attendencOj?.status === "end_shift"
              ) || [];
            const endDate = moment(endShift[endShift?.length - 1]?.date_time);
            let duration = moment.duration(
              endDate.diff(startShift[0]?.date_time)
            );
            let productionHurs = duration.hours();
            var hours = duration.hours(); //hours instead of asHours
            var minutes = duration.minutes(); //minutes instead of asMinutes
            // :
            // "start_shift"
            // attendanceData attendanceData
            return (
              <TableRow key={idx}>
                <TableCell>{userData?.name || "--"}</TableCell>
                {/* <TableCell>{item.farmers.length || "--"}</TableCell> */}
                <TableCell>
                  {startShift && startShift[0]
                    ? startShift[0]?.date_time
                    : "--"}
                </TableCell>
                <TableCell>
                  {endShift && endShift[endShift.length - 1]
                    ? endShift[endShift.length - 1]?.date_time
                    : "--"}
                </TableCell>
                <TableCell>{"--"}</TableCell>
                <TableCell>{`${hours}:${minutes}` || "--"}</TableCell>
                {/* <TableCell>
                {moment(project.start_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
              <TableCell>
                {moment(project.end_date).format(
                  DATE_FORMATS.DATE_ONLY_FORMAT
                ) || "--"}
              </TableCell>
              <TableCell>
                {project.district ? project.district.name : "--"}
              </TableCell>
              <TableCell>
                <Button
                  color="primary"
                  onClick={() => viewProjectDetail(project)}
                >
                  View details
                </Button>
              </TableCell> */}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer
        style={{
          justifyContent: "flex-end",
        }}
      >
        <GridItem xs={12} sm={12} md={12} style={{ maxWidth: "120px" }}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-to-xls"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Export Data"
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} style={{ marginBottom: "15px" }}>
          <DatePicker
            autoOk
            disableToolbar
            variant="inline"
            label="Select From Date"
            value={fromDate}
            onChange={setFromDate}
          />
          <DatePicker
            autoOk
            disableToolbar
            variant="inline"
            label="Select To Date"
            value={toDate}
            onChange={setToDate}
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          {attendanceData ? (
            renderProject()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Data Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
